import { createContext, useContext, useMemo, useState, type ReactNode } from 'react'
import type { LayerId, Pacing, Perspective } from '../types'

interface OrionState {
  perspective: Perspective
  setPerspective: (p: Perspective) => void
  pacing: Pacing
  setPacing: (p: Pacing) => void
  activeLayer: LayerId
  setActiveLayer: (l: LayerId) => void
}

const OrionContext = createContext<OrionState | null>(null)

export function OrionProvider({ children }: { children: ReactNode }) {
  const [perspective, setPerspective] = useState<Perspective>('cto')
  const [pacing, setPacing] = useState<Pacing>('standard')
  const [activeLayer, setActiveLayer] = useState<LayerId>('L1')

  const value = useMemo(
    () => ({ perspective, setPerspective, pacing, setPacing, activeLayer, setActiveLayer }),
    [perspective, pacing, activeLayer],
  )

  return <OrionContext.Provider value={value}>{children}</OrionContext.Provider>
}

export function useOrion(): OrionState {
  const ctx = useContext(OrionContext)
  if (!ctx) throw new Error('useOrion must be used inside <OrionProvider>')
  return ctx
}
